import { ReactNode } from 'react'

export const Layout = ({ children }: { children: ReactNode}) => {
  return (
    <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      {children}
    </div>
  )
}
